
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-lottie__top{
    display:flex;
    flex-direction:column;
    gap:1rem;
    margin-bottom:4.5rem;
  }
  .se-lottie__cell{
    display:flex;
    flex-direction:column;
    gap:1rem;
  }
  .se-lottie__cta{
    display:flex;
    flex-direction:column;
    gap:2rem;
    border:1px solid white;
    padding:2rem;
  }

:host{
  color:white;
}

slot[name='heading']::slotted(*){
  max-width:42rem;
}

slot[name='description']::slotted(*){
  max-width:42rem;
  font-size:22px;
}

[data-animation]{
  width:8rem;
}

slot[name^='slot']::slotted(*){
  font-family:'DM Sans';
  font-weight:500;
  font-size:30px;
  line-height:41px;
}

se-container{
  z-index:1;
  padding-block:3rem;
}

@media (prefers-reduced-motion: no-preference){
  .revealing{
    animation:revealing 1s ease-in-out;
  }
}

@keyframes revealing{
  from{
    transform:translateX(-100%);
  }
  to{
    transform:translateX(0px);
  }
}
`;